import { getApp, getApps, initializeApp, type FirebaseApp } from "firebase/app";
import { getMessaging, isSupported, type Messaging } from "firebase/messaging";

export const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
};



export const firebaseApp: FirebaseApp | null =
  typeof window === "undefined"
    ? null
    : getApps().length
      ? getApp()
      : (() => {
          try {
            return initializeApp(firebaseConfig);
          } catch (error) {
            console.error("Firebase init failed:", error);
            return null;
          }
        })();

let messagingPromise: Promise<Messaging | null> | null = null;

export function getMessagingInstance(): Promise<Messaging | null> {
  if (!firebaseApp) {
    console.warn("Messaging requested but firebaseApp is null");
    return Promise.resolve(null);
  }
  if (!messagingPromise) {
    messagingPromise = isSupported().then((supported) => {
      console.log("Is Messaging Supported?", supported);
      return supported && firebaseApp ? getMessaging(firebaseApp) : null;
    });
  }
  return messagingPromise;
}